module.exports = require("react-pdf/dist/esm/entry.webpack");